<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
    <main class="page-content">
        <div class="bgColor">
            <div class="container">
                 <div class="row align-items-center py-3">
          <div class="col-md-6">
            <p class="appTitle mb-0">Colleges</p>
          </div>

          <div class="col-md-6 text-end">
            <div class="admin-info d-inline-flex align-items-center">
              <span class="adminName me-2">{{ adminName }}</span>
             <img
      width="30"
      height="30"
      src="assets/tenant-avatar.jpg"
      class="rounded-circle"
      style="margin-left: 0.5em; vertical-align: middle"
    />
            </div>
          </div>
        </div>

               <div class="row my-4">
  <div class="col">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="search-wrapper position-relative">
            <input
              class="form-control search-input"
              (input)="onChangeEvent($event)"
              type="text"
              placeholder="🔍 Search Course..."
              [(ngModel)]="searchval"
              aria-label="Search"
            />
            <button
              class="clear-btn"
              *ngIf="searchval"
              (click)="reset()"
              type="button"
              aria-label="Clear search"
            >
              ✖
            </button>
          </div>
        </div>

        <div class="col-md-6 text-end">
          <button
            type="button"
            class="btn btn-primary addCourseBtn"
            (click)="openAdd()"
          >
            <i class="fa fa-plus" aria-hidden="true"></i> Add Course
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

                <div class="row" *ngIf="showData">
                    <div class="col-md-5 degreeContent" *ngFor="let course of allCourse">
                        <div class="row">
                            <div class="col-md-8">
                                <p style="text-align: left;font-size: 0.8em;">{{ course.courses }}</p>
                            </div>
                            <div class="col-md-4">
                                <i class="fa fa-trash-o iconEdit" #boxCourse (mouseover)="onMouseOver($event)" aria-hidden="true" (click)="deleteCourse(course)"></i>
                                <i class="fa fa-pencil iconEdit" #boxCourse (mouseover)="onMouseOver($event)" (click)="editCourse(course)"
                                        aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="noData" *ngIf="showNodata">
                    <h2>Currenly No Data Available!</h2>
                </div>

            </div>

            <div class="backdrop" [ngStyle]="{'display':display}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" *ngIf="showAdd">
                            Add Courses
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="modal-header" *ngIf="showEdit">
                            Edit Courses
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl">
                            <form [formGroup]="courseForm">
                                <label>Course Name</label>
                                <input type="text" class="form-control" formControlName="courseval" [(ngModel)]="courseName">
                                <div class="error-messages">
                                    <div *ngFor="let error of error_messages.courseval">
                                        <div class="error-message" *ngIf="courseForm.get('courseval').hasError(error.type) && (courseForm.get('courseval').dirty || courseForm.get('courseval').touched)">
                                            {{ error.message }}
                                        </div>
                                    </div>
                                </div>

                                <div class="addBtn" *ngIf="showAdd">
                                    <button class="commonBtn mt-2" [disabled]="!courseForm.valid" (click)="addCourse()">
                                        Add
                                        Course</button>
                                </div>

                                <div class="addBtn" *ngIf="showEdit">
                                    <button class="commonBtn mt-2" [disabled]="!courseForm.valid" (click)="updateCourse()">
                                        Update</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
            <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
                            <p>Do you want to delete Course ?</p>
                            <button type="submit" class="btn btn-success" (click)="delete()" style="width: 20%;">Yes</button>
                            <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">No</button><br><br>
                            <p class="error" *ngIf="showErr">{{ deleteErr }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>
</div>